module.exports = __webpack_public_path__ + "img/9788993824834.5c8aff90.jpg";